var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "mt-3": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            {
              attrs: {
                lg4: "",
                md4: "",
                sm12: "",
                xs12: "",
                "ml-2": "",
                "mr-2": ""
              }
            },
            [
              _c("h1", [_vm._v("Okay. Almost there!")]),
              _vm._v(" "),
              _c("p", { staticStyle: { "font-size": "1.3em" } }, [
                _vm._v("\n        You are submitting "),
                _c("b", [_vm._v(_vm._s(_vm.art.art.art_title))]),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("to")]),
                _vm._v(" "),
                _c(
                  "ul",
                  { attrs: { id: "example-1" } },
                  _vm._l(_vm.businesses_being_submitted, function(business) {
                    return _c("li", [
                      _vm._v(
                        "\n        " +
                          _vm._s(business.business_name) +
                          "\n      "
                      )
                    ])
                  })
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons hidden-sm-and-down" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        depressed: "",
                        dark: "",
                        large: "",
                        color: "black"
                      },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { depressed: "", large: "", color: "primary" },
                      on: { click: _vm.submit_art }
                    },
                    [_vm._v("Submit")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              attrs: {
                lg6: "",
                md6: "",
                sm12: "",
                xs12: "",
                "ml-2": "",
                "mr-2": ""
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.art.art.url, alt: "", width: "100%" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { sm12: "", xs12: "", "ml-2": "", "mr-2": "" } },
            [
              _c(
                "div",
                { staticClass: "buttons hidden-md-and-up" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        depressed: "",
                        dark: "",
                        large: "",
                        color: "black"
                      },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { depressed: "", large: "", color: "primary" },
                      on: { click: _vm.submit_art }
                    },
                    [_vm._v("Submit")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-055b6701", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-055b6701","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/submit_result.vue
// module id = null
// module chunks = 